import { Add, Check } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { KeyDrivePrimaryButton } from "../../../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { WorkSpaceCreate } from "../../../../../../model/WorkSpaceModel";

interface IConfigWorkspaceHeader {
    createItem: WorkSpaceCreate;
    handleCreate: (createItem: WorkSpaceCreate) => void;
    idWorkspace: string | undefined;
    disabled?: boolean
}

export const ConfigWorkspaceHeader: React.FC<IConfigWorkspaceHeader> = ({
    handleCreate,
    createItem,
    idWorkspace,
    disabled
}) => {

    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            marginTop="15px"
            marginBottom="15px"
        >
            <Box
                display="flex"
            >
                <Add 
                    sx={{
                        color: "#22638D",
                        width: "24px",
                        height: "24px"
                    }}
                />
                <Typography
                    sx={{
                        textAlign: "left",
                        font: "normal normal 600 20px/27px Segoe UI",
                        letterSpacing: "0px",
                        color: "#2D2D2D",
                        opacity: 1,
                        marginLeft: "12px"
                    }}
                >
                    { idWorkspace != undefined ? t("AdminConsole.UpdateWorkspaceTitle") : t("AdminConsole.NewWorkspaceTitle") } 
                </Typography>
            </Box>
            <Box>
                <KeyDrivePrimaryButton 
                    disabled={disabled}
                    startIcon={<Check />}
                    onClick={() => handleCreate(createItem)}
                    TextComponent={KeyDriveBodyMin}
                    TextComponentProps={{
                        color: "#FFFFFF",
                        needBold: false,
                        needEllipses: false,
                        text: idWorkspace != undefined ? t("AdminConsole.UpdateWorkspace") : t("AdminConsole.CreateWorkspace")
                    }}
                />
            </Box>
        </Box>
    )
}